import {Component, OnInit} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {VersionCheckService} from "./version-check.service";
import {OneSignalService} from "./onesignal.service";
import {environment} from "../environments/environment";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'app';

  constructor(private translate: TranslateService, private versionCheck: VersionCheckService, private oneSignal: OneSignalService) {
    translate.setDefaultLang('it');
    translate.use('it');
  }
  ngOnInit() {
    const url = new URL(window.location.href);
    if (url.searchParams.has('_reload')) {
      url.searchParams.delete('_reload');
      window.history.replaceState({}, document.title, url.pathname);
    }
    if(OneSignalService.isEnabled())
      this.oneSignal.onInit().then(() => {
        console.log('OneSignal initialized');
        this.oneSignal.storeUserID();
      });


    this.versionCheck.initVersionCheck(60000);
  }
}
